import { ProviderDetailPage } from '../ProviderDetailPage';
import type { ProviderMeta } from '../ProviderDetailPage';

const META: ProviderMeta = {
  slug: 'uber',
  name: 'Uber Eats',
  tagline: 'Uber Eats delivery network integration via the Uber Direct API',
  colorClass: 'bg-[var(--chart-2)]',
  initial: 'U',
  webhookPath: '/webhooks/delivery/uber',
  feeNote:
    'Uber Direct (the B2B delivery API) charges a flat booking fee plus distance-based pricing. ' +
    'Typical Nairobi rates: KES 80–150 base + KES 20–30/km. Uber Direct requires an approved ' +
    'Business Account and Uber Direct API access. Contact your Uber account manager to obtain ' +
    'API credentials. Chekit retains its standard delivery service fee (10% or configured %) ' +
    'on top of any third-party payout.',
};

export const UberConfigPage = () => <ProviderDetailPage meta={META} />;
